import { render, staticRenderFns } from "./floorPlan copy 2.vue?vue&type=template&id=abec3b2a"
import script from "./floorPlan copy 2.vue?vue&type=script&lang=js"
export * from "./floorPlan copy 2.vue?vue&type=script&lang=js"
import style0 from "./floorPlan copy 2.vue?vue&type=style&index=0&id=abec3b2a&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abec3b2a')) {
      api.createRecord('abec3b2a', component.options)
    } else {
      api.reload('abec3b2a', component.options)
    }
    module.hot.accept("./floorPlan copy 2.vue?vue&type=template&id=abec3b2a", function () {
      api.rerender('abec3b2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/base/floorPlan copy 2.vue"
export default component.exports